import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Button, Card, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import CreateUpdateAgentModal from "../modals/CreateUpdateAgentModal";
import ChangeAgentPasswordModal from "../modals/ChangeAgentPasswordModal";
import API from "../helpers/api";


export default function Admin() {
    const user = useSelector(state => state.user.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const api = useMemo(() => new API({dispatch}), [dispatch]);
    const [agents, setAgents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [showAgentModal, setShowAgentModal] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const checkOnline = async () => {
        try {
            await api.checkAuth();
            return true;
        } catch (error) {
            console.error('Error checking auth:', error);
            return false;
        }
    }

    const buildAgentsSection = () => {
        return (
            <div>
                <hr/>
                <h4 className="text-center">Agents</h4>
                
                <Table striped bordered hover variant="dark">
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Admin</th>
                            <th>Status</th>
                            <th>Update</th>
                        </tr>
                    </thead>

                    <tbody>
                        {agents.map((agent, index) => {
                            return (
                                <tr key={index}>
                                    <td>{agent.first_name}</td>
                                    <td>{agent.last_name}</td>
                                    <td>{agent.email}</td>
                                    <td>{agent.is_admin ? 'Yes' : 'No'}</td>
                                    <td>{agent.is_active ? 'Active' : 'Inactive'}</td>
                                    <td >
                                        <Button disabled={agent.id == user.id} onClick={() => {
                                            setSelectedAgent(agent);
                                            setShowAgentModal(true);
                                        }}>Update</Button>
                                        {" "}
                                        <Button onClick={() => {
                                            setSelectedAgent(agent);
                                            setShowChangePasswordModal(true);
                                        }}>Change Password</Button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>
                

        )
    }


    const getAgents = async () => {
        setLoading(true);
        if (!await checkOnline()){
            navigate('/');
            return;
        }
        try {
            const response = await api.getAllAgents();
            console.log(response);
            setAgents(response);
            setLoading(false);
        } catch(err){
            console.error('Error fetching agents:', err);
            setLoading(false);
        }   
    }

    useEffect(() => {
        getAgents();
    }, [])

    if (!user || !user.is_admin || loading) return null;

    let modal = null;
    if (showAgentModal) {
        modal = (
            <CreateUpdateAgentModal
                show={showAgentModal}
                close={() => {
                    setShowAgentModal(false);
                    setSelectedAgent(null);
                    getAgents();
                }}
                agent={selectedAgent}
            />
        );
    } else if (showChangePasswordModal && selectedAgent) {
        modal = (
            <ChangeAgentPasswordModal
                show={showChangePasswordModal}
                close={() => {
                    setShowChangePasswordModal(false);
                    setSelectedAgent(null);
                }}
                agent={selectedAgent}
            />
        );
    }
    

    return (
        <Container className="mt-4">
            {modal}
            <Card bg="dark" text="white">
                <Card.Header><h4>Admin Dashboard</h4></Card.Header>
                <Card.Body>
                    <Row className="mb-3">
                        <Col>
                            <h2>Admin Dashboard</h2>
                        </Col>
                        <Col className="text-end">
                            <Button variant="primary" onClick={() => {
                                setSelectedAgent(null);
                                setShowAgentModal(true);
                            }}>
                                Create Agent
                            </Button>
                        </Col>
                    </Row>

                    <Row>
                        {buildAgentsSection()}
                    </Row>
                </Card.Body>
            </Card>
        </Container>
    );
}